import React, { useMemo } from 'react'
import { BlockMain } from '@blocks/BlockMain'
import { MainBlock } from '@blocks/BlockMain/model'
import { LeadProductType } from '@features/types'
import { ApplicationForms } from '@shared/components/forms/application'
import { scrollToApplicationForm } from '@shared/components/forms/application/cross'
import { ApplicationFormData } from '@shared/components/forms/application/cross-new/types'
import PageAnimation from '@shared/components/page-animation'
import { Section } from '@shared/components/section'
import { AppSection } from '@shared/components/sections/app'
// import { YouTube } from '@shared/components/sections/youtube'
import { Offers } from '@shared/components/sections/offers'
import { Rate } from '@shared/components/sections/rate'
// import { Journal } from '@shared/components/sections/journal'
import { RiskPoints } from '@shared/components/sections/riskPoints'
import { StepsNoSection } from '@shared/components/sections/steps'
import { mainBlock } from 'data/newLP'

import { stepsData } from './sections/steps/data'

import styles from './style.module.scss'

interface Props {
	mainBlockPath?: Partial<MainBlock>
	rateButtonText?: string
	titleGetLoan?: string
	ratePoints?: string[]
	minLoan?: number
	maxLoan?: number
	minPeriod?: number
	maxPeriod?: number
	isAutoLoan?: boolean
	hideOffers?: boolean | undefined
	leadProductType?: LeadProductType | undefined
	applicationFormTitle?: string | undefined
	applicationFormProgressTitle?: string | undefined
}

export const View = ({
	mainBlockPath,
	ratePoints,
	minLoan,
	maxLoan,
	minPeriod,
	maxPeriod,
	isAutoLoan = true,
	rateButtonText = 'Получить кредит сейчас',
	titleGetLoan = '3 простых шага для получения кредита',
	hideOffers,
	leadProductType = 'REAL_ESTATE_LOAN',
	applicationFormTitle = 'Заявка на заём',
	applicationFormProgressTitle = 'Вероятность одобрения займа',
}: Props) => {
	const formData = useMemo<ApplicationFormData>(() => ({ leadProductType }), [leadProductType])

	return (
		<PageAnimation>
			<BlockMain
				adornmentClassname={styles.mainAdornment}
				imageAdornmentWrapClassName={styles.imageAdornment}
				data={{ ...mainBlock, ...mainBlockPath }}
				buttonProps={{
					onClick: scrollToApplicationForm,
				}}
			/>
			{isAutoLoan && !hideOffers && (
				<Section className={styles.offerWrap} fullWidth>
					<h2 className={styles.sectionTitle}>
						Единое окно для получения любого кредита. По низким ставкам
					</h2>
					<Offers />
				</Section>
			)}
			<Section className={styles.appWrap} fullWidth>
				<Rate points={ratePoints} buttonText={rateButtonText} />
				<AppSection />
			</Section>
			<Section className={styles.stepsWrap} fullWidth>
				<h2 className={styles.sectionTitle}>{titleGetLoan}</h2>
				<StepsNoSection stepTextStyles={styles.extraTextStyles} steps={stepsData} />
				<h2 className={styles.sectionTitle}>Вы не рискуете</h2>
				<RiskPoints isAutoLoan={!isAutoLoan} />
			</Section>
			<ApplicationForms.CrossNew
				processBarText={applicationFormProgressTitle}
				formTitle={applicationFormTitle}
				minLoan={minLoan}
				maxLoan={maxLoan}
				minPeriod={minPeriod}
				maxPeriod={maxPeriod}
				data={formData}
			/>
		</PageAnimation>
	)
}
